import type { PricedEquipment } from "~/graphql/client"

export const MOUNT_SELECTION_OPTIONS = {
  "Roof Mount": `roof_mount`,
  "Ground Mount": `ground_mount`,
  "Both": `both`,
}

export const DEFAULT_SOLAR_MODULE_EQUIPMENT: PricedEquipment = {
  basicAdderAssociations: [],
  childEquipmentAssociations: [],
  compatibleInverterManufacturers: [],
  createdAt: ``,
  catalogNumber: ``,
  currentProposalPrice: 0,
  deprecated_id: null,
  description: ``,
  equipmentType: {
    createdAt: ``,
    id: ``,
    name: ``,
    powurOsId: 0,
    updatedAt: ``,
    equipment: [],
  },
  equipmentTypeId: ``,
  fallbackPrice: 0,
  height: 70,
  id: 0,
  inverterData: null,
  manufacturer: {
    id: ``,
    createdAt: ``,
    updatedAt: ``,
    name: ``,
    powurOsId: 0,
  },
  manufacturerId: ``,
  moduleData: {
    id: ``,
    relatedOptimizerId: 0,
    relatedOptimizer: null,
    recommendedMicroinverterId: 0,
    recommendedMicroinverter: null,
    openCircuitVoltage: 0,
    voltageAtMPP: 0,
    temperatureCoefficientPmpp: 0,
    temperatureCoefficientVoc: 0,
  },
  name: ``,
  parentEquipmentAssociations: [],
  powurOsEquipmentTypeId: 0,
  powurOsManufacturerId: 0,
  proposalPrices: [],
  powurOsInverterDataId: 0,
  powurOsModuleDataId: 0,
  powurOsEnergyBackupDataId: null,
  energyBackupData: null,
  updatedAt: ``,
  warranty: null,
  wattage: 100,
  width: 50,
  cecWeightedEfficiency: 0,
  isKit: false,
  isDefault: false,
}

export const DEFAULT_INVERTER: PricedEquipment = {
  basicAdderAssociations: [],
  childEquipmentAssociations: [],
  compatibleInverterManufacturers: [],
  createdAt: ``,
  catalogNumber: ``,
  currentProposalPrice: 0,
  deprecated_id: null,
  description: ``,
  equipmentType: {
    createdAt: ``,
    id: ``,
    name: ``,
    powurOsId: 0,
    updatedAt: ``,
    equipment: [],
  },
  equipmentTypeId: ``,
  fallbackPrice: 0,
  height: 70,
  id: 0,
  inverterData: {
    id: 0,
    maxInputDcPower: 100,
    isBatteryCompatible: false,
    isBattery: false,
    minimumPVOperatingDCInputVoltage: 0,
    maximumPVOperatingDCInputVoltage: 0,
    maximumSolarInputOnGridWatts: 0,
    isStringInverter: false,
    maximumNumberOfStrings: 0,
  },
  manufacturer: {
    id: ``,
    createdAt: ``,
    updatedAt: ``,
    name: ``,
    powurOsId: 0,
  },
  manufacturerId: ``,
  moduleData: null,
  name: ``,
  parentEquipmentAssociations: [],
  powurOsEquipmentTypeId: 0,
  powurOsManufacturerId: 0,
  proposalPrices: [],
  powurOsInverterDataId: 0,
  powurOsModuleDataId: 0,
  powurOsEnergyBackupDataId: null,
  energyBackupData: null,
  updatedAt: ``,
  warranty: null,
  wattage: 100,
  width: 50,
  cecWeightedEfficiency: 0,
  isKit: false,
  isDefault: false,
}

export const DEFAULT_BATTERY: PricedEquipment = {
  basicAdderAssociations: [],
  childEquipmentAssociations: [],
  compatibleInverterManufacturers: [],
  createdAt: ``,
  catalogNumber: ``,
  currentProposalPrice: 0,
  deprecated_id: null,
  description: ``,
  equipmentType: {
    createdAt: ``,
    id: ``,
    name: ``,
    powurOsId: 0,
    updatedAt: ``,
    equipment: [],
  },
  equipmentTypeId: ``,
  fallbackPrice: 0,
  height: 70,
  id: 0,
  inverterData: null,
  manufacturer: {
    id: ``,
    createdAt: ``,
    updatedAt: ``,
    name: ``,
    powurOsId: 0,
  },
  manufacturerId: ``,
  moduleData: null,
  name: ``,
  parentEquipmentAssociations: [],
  powurOsEquipmentTypeId: 0,
  powurOsManufacturerId: 0,
  proposalPrices: [],
  powurOsInverterDataId: 0,
  powurOsModuleDataId: 0,
  powurOsEnergyBackupDataId: null,
  energyBackupData: null,
  updatedAt: ``,
  warranty: null,
  wattage: 100,
  width: 50,
  cecWeightedEfficiency: 0,
  isKit: false,
  isDefault: false,
}
